<vdr-card [title]="'Product Sales' | translate" class="sales-metrics">
    <div class="sales-metrics__filters">
        <div class="sales-metrics__filter">
            <label for="sales-start-date">Start date</label>
            <input id="sales-start-date" type="date" (change)="setStartDate($event.target.value)" />
        </div>
        <div class="sales-metrics__filter">
            <label for="sales-end-date">End date</label>
            <input id="sales-end-date" type="date" (change)="setEndDate($event.target.value)" />
        </div>
    </div>
    <vdr-data-table-2
        id="customer-sales-metrics"
        [items]="items$ | async"
        [itemsPerPage]="itemsPerPage$ | async"
        [totalItems]="totalItems$ | async"
        [currentPage]="currentPage$ | async"
        (pageChange)="setPageNumber($event)"
        (itemsPerPageChange)="setItemsPerPage($event)"
    >
        <vdr-dt2-column id="variant" heading="Variant" [optional]="false">
            <ng-template let-item="item">
                <a
                    class="button-ghost"
                    [routerLink]="[
                        '/catalog',
                        'products',
                        item.productVariant.productId,
                        'variants',
                        item.productVariant.id,
                    ]"
                >
                    <span>{{ item.productVariant.name }}</span>
                    <clr-icon shape="arrow right"></clr-icon>
                </a>
            </ng-template>
        </vdr-dt2-column>
        <vdr-dt2-column id="quantity" heading="Quantity" [optional]="false">
            <ng-template let-item="item">
                <span class="right">{{ item.quantity }}</span>
            </ng-template>
        </vdr-dt2-column>
    </vdr-data-table-2>
</vdr-card>
